import { render, staticRenderFns } from "./CreateRoleView.vue?vue&type=template&id=328d97bd&scoped=true&"
import script from "./CreateRoleView.vue?vue&type=script&lang=js&"
export * from "./CreateRoleView.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoleView.vue?vue&type=style&index=0&id=328d97bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d97bd",
  null
  
)

export default component.exports